import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { ProethicaTestBadge } from "components/ProethicaTestBadge";
import { Image } from "expo-image";
import { Avatar } from "react-native-paper";

export const getModuleFallbackIcon = ({
	isTest,
	icon,
}: {
	isTest?: boolean;
	icon?: string;
}): string => {
	if (isTest) {
		return icon ?? "clipboard-text-outline";
	}
	return "book-open-outline";
};

type Props = {
	size: number;
	title: string;
	thumbnailSource?: string | number | { uri: string };
	thumbnailUrl?: string;
	locked?: boolean;
	isTest?: boolean;
	testKind?: "pretest" | "posttest";
	icon?: string;
};

export const ModuleThumbnail = ({
	size,
	title,
	thumbnailSource,
	thumbnailUrl,
	isTest,
	testKind,
	icon,
}: Props) => {
	const theme = useAppTheme();
	const finalThumbnailSource =
		thumbnailSource ?? (thumbnailUrl ? { uri: thumbnailUrl } : undefined);
	const fallbackIcon = getModuleFallbackIcon({ isTest, icon });

	return (
		<Box style={{ position: "relative", width: size, height: size }}>
			{finalThumbnailSource ? (
				<Image
					source={finalThumbnailSource}
					style={{
						width: size,
						height: size,
						borderRadius: theme.roundness,
					}}
					contentFit="contain"
					alt={title}
				/>
			) : isTest && testKind ? (
				<ProethicaTestBadge kind={testKind} size={size} />
			) : (
				<Box
					style={{
						width: size,
						height: size,
						borderRadius: theme.roundness,
						backgroundColor: theme.colors.surfaceVariant,
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Avatar.Icon
						size={size / 2}
						icon={fallbackIcon}
						style={{ backgroundColor: "transparent" }}
						color={
							isTest ? theme.colors.primary : theme.colors.onSurfaceVariant
						}
					/>
				</Box>
			)}
		</Box>
	);
};
